export const AnimationTime = {
  GraphAnimation: 0.5,
  CircleAnimation: 0.1,
  CheckboxAnimation: 0.2,
  DelayBetweenSteps: 0.2,
  DelayForCheckBox: 0.3,
};
